export default __webpack_public_path__ + "static/bariol_serif_regular_italic-webfont-82114a10334d433285d33e2012d731a9.svg";